import { Formik, Form, Field, ErrorMessage } from "formik";
import { useState } from "react";
import * as yup from 'yup';
import ResponsiveTabs from "../../../components/OB/Tabbar";
import { Box } from "@mui/material";
import ListHeaderComponent from "../../../components/OB/ListHeaderComponent";
import KatsayilarVeDegerlemeOrani from "./EmlakVergisiTarifeleriTabs/KatsayilarVeDegerlemeOrani";
import InsaatMaliyetBedelleri from "./EmlakVergisiTarifeleriTabs/InsaatMaliyetBedelleri";
import BinaAsinmaOranlari from "./EmlakVergisiTarifeleriTabs/BinaAsinmaOranlari";
import ArsaAraziM2BirimDegeriSorgulama from "./EmlakVergisiTarifeleriTabs/ArsaAraziM2BirimDegeriSorgulama";


const EmlakVergisiTarifeleri = () => {
    const [value, setValue] = useState(0);

    const handleChange = (event: any, newValue: any) => {
        setValue(newValue);
    };

    return (
        <div>
            <ResponsiveTabs
                items={[
                    { title: "Arsa-Arazi M2 Birim Değeri", onClick: () => console.log("Tab 1 clicked") },
                    { title: "Bina Aşınma Oranları", onClick: () => console.log("Tab 2 clicked") },
                    { title: "İnşaat Maliyet Bedelleri", onClick: () => console.log("Tab 3 clicked") },
                    { title: "Katsayılar Ve Değerleme Oranı", onClick: () => console.log("Tab 4 clicked") },
                ]}
                value={value}
                onChange={handleChange}
                spreadWidth={true}
            />
            <Box className="pt-2">
                {value === 0 && <ArsaAraziM2BirimDegeriSorgulama />}
                {value === 1 && <BinaAsinmaOranlari />}
                {value === 2 && <InsaatMaliyetBedelleri />}
                {value === 3 && <KatsayilarVeDegerlemeOrani />}
            </Box>
        </div>
    );
};

export default EmlakVergisiTarifeleri;